// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
export interface HceGenderPrediction {
    coverage: {
        autosome_mean_cov: number;
        X_mean_cov: number;
        Y_mean_cov: number;
        'Y_cov / X_cov': number;
    };
    ploidy: {
        autosome_mean_ploidy: number;
        X_mean_ploidy: number;
        Y_mean_ploidy: number;
        'Y_ploidy / X_ploidy': number;
    };
    gender: HceGender;
    version: string;
}

export const HceGender = {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown',
} as const;

export type HceGender = typeof HceGender[keyof typeof HceGender];
